import { apiClient, signApiRequest } from ".";
import { useQuery } from "@tanstack/react-query";
import { CustomerCredentials } from "../ui/customerDataStore";
import * as Sentry from "@sentry/react";

export const getLockedAdvice = async ({
  credentials,
}: {
  credentials: CustomerCredentials;
}) => {
  const signedRequest = await signApiRequest(
    "GET",
    `${import.meta.env.VITE_API_URL}/advice/advice-lock?fid=${credentials.identityId}`,
    credentials,
    { "content-type": "application/json" },
  );

  const response = await apiClient(signedRequest);

  return response.data;
};

export const useGetLockedAdvice = ({
  credentials,
  enabled = true,
}: {
  credentials: CustomerCredentials;
  enabled?: boolean;
}) => {
  return useQuery({
    enabled,
    queryKey: ["get-locked-advice-by-user-id"],
    queryFn: () => getLockedAdvice({ credentials }),
    throwOnError: (error) => {
      Sentry.captureException(error, {
        tags: {
          operation: "get-locked-advice-by-user-id",
          errorType: error.name || "UnknownError",
        },
        extra: {
          apiEndpoint: "/advice/advice-lock?fid=${identityId}",
        },
        level: "error",
      });
      return true;
    },
  });
};
